// @flow

// Types
import type {
  Asset,
  AssetsById,
} from 'fc-model-assets/types'

// Constants
import {
  PROP_ASSET_ID,
  PROP_PARENT,
  PROP_CATEGORY,
  PROP_SHAPE,
} from 'fc-model-assets'

// Libs
import _map from 'lodash/map'
import _reduce from 'lodash/reduce'

// Utils
import getAncestors from './getAncestors'

// Local Types
type Index = { [number]: Array<number> }

// Exports
export default function buildAncestorsIndex (assets: AssetsById): Index {
  return _reduce(assets, (acc: Index, {
    [PROP_ASSET_ID]: id,
    [PROP_PARENT]: parent,
    [PROP_CATEGORY]: category,
    [PROP_SHAPE]: shape,
    }: Asset): Index => {
    //
    acc[id] = _map(getAncestors(assets, id), PROP_ASSET_ID)

    return acc
  }, {})
}
